import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledMlpSkeletonWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.dynamic0100};
    `;
  }}
`;

export const StyledTopSection: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const StyledBottomSection: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static350};

      @media (min-width: ${Breakpoints.b960}px) {
        flex-direction: row;
      }
    `;
  }}
`;

export const StyledInnerLeftSection: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      flex: 1 0 0;
      gap: ${theme.size.static300};
    `;
  }}
`;

export const StyledInnerLeftTopSection: any = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${Breakpoints.b960}px) {
    padding-right: 27px;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    padding-right: 32px;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    padding-right: 40px;
  }
`;

export const StyledInnerRightSection: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      flex: 1 0 0;
      gap: ${theme.size.static350};
    `;
  }}
`;

export const StyledInnerRightTopSection: any = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
`;

export const StyledInnerRightBottomSection: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      align-self: stretch;
      display: flex;
      gap: ${theme.size.static350};

      @media (max-width: 959px) {
        flex-direction: column;
        gap: ${theme.size.static200};
      }

      @media (min-width: ${Breakpoints.b960}px) {
        padding-right: 8px;
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        padding-right: 68px;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding-right: 168px;
      }
    `;
  }}
`;